 /*
  Create By Sittikron : 06/06/2023
  Update By Sittikron : 9/08/2023  - เพิ่ม Permissionในการตรวจสอบ
  Update By Sittikron : 28/08/2023 - แก้ไขสิทธิทุกหน้า ที่เรียกการใช้  สิทธิ view  เปลี่ยนวิธีเขียนใหม่  ให้เหมือนหน้า m_project.js
  Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
  Update By POOM : 03/05/2024  
    - เพิ่มการแสดงข้อมูล Rate ราคา PER DIEM  ต่อวัน   (baht/day) , Rate ราคา travel ต่อกิโลเมตร   (baht/km)
    
  Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
  
  Edit By POOM : 2024-05-13  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
	
 
 */
import React, { useEffect, useState } from "react";
import Pathurl from "../Class/Pathurl.json";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ConfigETC from "../Class/ConfigETC.json";
import {
  Class_ETC_MsgError,
  Class_ETC_MsgSuccess,
  Class_ETC_Warning,
  Class_ETC_Encrypt,
  Class_ETC_SessionTimeOut
  ,HtmlTooltip
} from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
//Table
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PaginationActions from "../PartialView/PaginationActions"

import { CP_CheckPermission } from "../Class/Class_Permission"

function M_position() {


  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isCount, setIsCount] = useState(0);
  const [listPosition, setListPosition] = useState([]);
  const [ ActEdit ] = useState(Class_ETC_Encrypt("Edit"));
  const [ ActAdd ] = useState(Class_ETC_Encrypt("Add"));

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);
   //#region ###################  Paging               ###################

   const [page, setPage] = useState(0);
   // eslint-disable-next-line
   const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //
 
   const handleChangePage = (event, newPage) => {
     setPage(newPage);
   };
 
   const handleChangeRowsPerPage = (event) => {
     setPage(0);
   };
 
   //#endregion

   //#region ###################  Open on load               ###################
   useEffect(() => {
    if (isFirst === true) {
      GetConfig();
      if (isLoadedConfigData === true) {    
        let ckpermission = CP_CheckPermission("master" , ["position_view"] , false , true)
        if (ckpermission === true) {
          setIsPermissionEdit(CP_CheckPermission("master" , ["position_edit"] , false , false))
          setIsPermissionDel(CP_CheckPermission("master" , ["position_delete"] , false , false))
          setIsPermissionAdd(CP_CheckPermission("master" , ["position_add"] , false , false))   
          BindList_Position("GET",function() {
            setIsFirst(false);
            setIsLoadProgress(false);
          });
        }
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadedConfigData]);
  
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

//#endregion

  //#region ###################  Bind Data   ########################

  async function BindList_Position(isAct , _callback) {

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");

    var raw = "";
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(configData.API_URL + "Position_Getlist", requestOptions)
      .then((response) => response.json())
      .then((result) => {

        if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else
        {
          if (result.total_Data > 0) {
            if (isAct === "DEL") {
              if (rowsPerPage * (page + 1) > result.total_Data) {
                let pagenow = Math.ceil(result.total_Data / rowsPerPage);
                setPage((pagenow === 0 ? 0 : pagenow - 1));
              }
            }
            else if (isAct === "GET") {
              setPage(0);
            }
            setListPosition(result.data);
            setIsCount(result.total_Data);
            if (_callback != null) {
              _callback();
            }
          } else {
            setListPosition([]);
            if (_callback != null) {
              _callback();
            }
          }

        }
      })
      .catch((error) => {
        setListPosition([]);
        if (_callback != null) {
          _callback();
      }
      });
  }

   //#endregion

  //#region ###################  Delete Data   ########################

   function Onclick_DeletePossition(Pos_id) {
      document.getElementById("hd_iddel").value = Pos_id;
     Class_ETC_Warning(MsgDescription.CFM002, DelPossition);
  };

   function DelPossition() {
    setIsLoadProgress(true);

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);
    var raw = JSON.stringify({
      "pos_id": document.getElementById("hd_iddel").value
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Position_Del", requestOptions)

      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {
          
          BindList_Position("DEL",function() {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          });

        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {

          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);

        }
      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR003, null);
      });
   };

    //#endregion

  //#region ###################  Sorting Data          ###################

  function Onclick_Sorting_Position (Act, Pos_id){
    
    setIsLoadProgress(true);

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);
    var raw = JSON.stringify({
      "pos_id": Pos_id.toString(),
      "act": Act.toString()
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Position_Sorting", requestOptions)

      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {

          BindList_Position("",function() {
            setIsLoadProgress(false);
          });
          
        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {

          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);

        }
      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  };

  //#endregion

  return (
    <>

      {isLoadProgress && (
        <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>Position list</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fas fa-graduation-cap" /> Position list
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                {/* SELECT2 EXAMPLE */}
                <div className="card  shadow">
                  <div className="card-header ">
                        <h3 className="card-title">
                          Result <small> ({listPosition.length} items)</small>
                        </h3>
                        <div className="float-right">
                          <div className="btn-group">
                          {(isPermissionAdd === true) &&
                            <div className="row">
                              <div className="col-md-12">
                              <Link
                                  to={"../" + Pathurl.m_position_ae}
                                  state={{ pos_id: Class_ETC_Encrypt('-1'), act: ActAdd }}
                                  className="btn btn-primary btn-sm"
                                >
                                  <i className="fa fa-plus" /> New Position
                                </Link>
                              </div>
                            </div>
                          }
                          {/* /.row (main row) */}
                          </div>
                        </div>
                  </div>
                  <div className="card-body p-0">
                  <TableContainer>
                  <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table table-head-fixed text-nowrap table-hover"
                          >
                      <TableHead>
                      <TableRow>
                          <TableCell
                            style={{ width: "3%" }}
                            rowSpan={2}
                            className="align-top"
                          >
                            <b>#</b>
                          </TableCell>
                          <TableCell
                            style={{ width: "15%" }}
                            rowSpan={2}
                            className="align-top"
                          >
                           <b>Position</b> 
                          </TableCell>
                          <TableCell
                            style={{ width: "15%" }}
                            colSpan={(isSVOT === true ? 4 : 3)}
                            className="text-center align-top border-right"
                          >
                           <b>Rate</b>  
                          </TableCell>
                          
                          <TableCell
                            style={{ width: "15%" }}
                            colSpan={2}
                            className="text-center align-top  border-right"
                          >
                            <b>Authority</b>
                            &nbsp;<HtmlTooltip
                            title={
                              <React.Fragment>
                                <div className="text-left">
                                  <p> <span className={ConfigETC.Timesheet_SelfApprove}>Self-Approve</span> <br/> Can approve yourself.</p>
                                  <p><span className={ConfigETC.Timesheet_Approver}>Approver</span><br/> Approve lower positions.</p>
                                  <p><span className={ConfigETC.Timesheet_Reviewer}>Reviewer</span><br/> Review lower positions.</p>
                                  
                              </div> 
                              </React.Fragment>
                            }
                          >
                            <i className="fas fa-info-circle "  ></i>
                          </HtmlTooltip>
                          </TableCell>


                          


                          <TableCell
                            style={{ width: "10%" }}
                            rowSpan={2}
                            className="align-top text-center"
                          >
                            <b>Status</b>
                          </TableCell>
                          <TableCell
                            style={{ width: "7%" }}
                            rowSpan={2}
                            className="align-top text-center"
                          >
                            <b>{isPermissionEdit === true ? "Sorting" : ""}</b>
                          </TableCell>
                          <TableCell style={{ width: "10%" }} rowSpan={2} > </TableCell>
                      </TableRow>
                      <TableRow>

                          <TableCell style={{ width: "7%" }} className="text-center align-top">
                          <b>WT</b> 
                          <br />
                            <small>(Baht/hr.)</small>
                          </TableCell>

                          {isSVOT === true &&
                          <>
                            <TableCell style={{ width: "8%" }} className="text-center align-top">
                            <b>OT</b> 
                            <br />
                            <small>(Baht/hr.)</small>
                            </TableCell>
                          </>
                          }


                        <TableCell
                            style={{ width: "10%" }}
                            rowSpan={2}
                            className="align-top text-center "
                          >
                            <b>Per diem allowance</b>  <br />
                            <small>(Baht/day)</small>
                          </TableCell>
                          <TableCell
                            style={{ width: "10%" }}
                            rowSpan={2}
                            className="align-top text-center border-right "
                          >
                            <b>Travel </b>  <br />
                            <small>(Baht/km.)</small>
                          </TableCell>

                          <TableCell style={{ width: "7%" }} className="text-center align-top">
                          <b>Timesheet</b> 
                          </TableCell>
                          {/* <TableCell style={{ width: "0%" }} className="text-center"> */}
                            {/* Payment */}
                          {/* </TableCell> */}
                          <TableCell style={{ width: "8%" }} className="text-center align-top border-right ">
                          <b>Timeoff</b> 
                          </TableCell>
                        </TableRow>
                        </TableHead>
                      <TableBody>
                      {(listPosition.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={9} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                              listPosition
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                      <TableRow key={row.pos_id}>
                                        <TableCell>
                                            <div>{row.rowindex}</div>
                                            <input type="hidden" id="hd_iddel" defaultValue={row.pos_id}></input>
                                            <input type="hidden" id="hd_act"></input>
                                        </TableCell>
                                        <TableCell>
                                          <div>
                                            <b>{row.pos_name}</b>
                                          </div>
                                        </TableCell>
                                        <TableCell className="text-center">
                                          <div>{row.pos_rate_WT_str}</div>
                                        </TableCell>

                                        {isSVOT === true && 
                                          <TableCell className="text-center">
                                            <div>{row.pos_rate_OT_str}</div>
                                          </TableCell>
                                        }
                                        <TableCell className="text-center">
                                          <div>{row.pos_rate_exp_extra_str}</div>
                                        </TableCell>
                                        <TableCell className="text-center border-right">
                                          <div>{row.pos_rate_exp_travel_str}</div>
                                        </TableCell>

                                        <TableCell className="text-center">
                                          <span
                                            className={
                                                  row.pos_auth_timesheet === 0 ? ConfigETC.Timesheet_None
                                                : row.pos_auth_timesheet === 1 ? ConfigETC.Timesheet_Reviewer
                                                : row.pos_auth_timesheet === 2 ? ConfigETC.Timesheet_Approver
                                                : ConfigETC.Timesheet_SelfApprove
                                              }
                                          >
                                            {row.pos_auth_timesheet_str}
                                          </span>
                                        </TableCell>
                                        {/* <TableCell className="text-center"> */}
                                          {/* <span
                                            className={
                                              row.pos_auth_payment === 1
                                                ? ConfigETC.Payment_Yes
                                                : ConfigETC.Payment_No
                                              }
                                          >
                                            {row.pos_auth_payment_str}
                                          </span> */}
                                        {/* </TableCell> */}
                                        <TableCell className="text-center  border-right">
                                          <span
                                            className={
                                                  row.pos_auth_timeoff === 0 ? ConfigETC.Timeoff_None
                                                : row.pos_auth_timeoff === 1 ? ConfigETC.Timeoff_Reviewer
                                                : row.pos_auth_timeoff === 2 ? ConfigETC.Timeoff_Approver
                                                : ConfigETC.Timeoff_SelfApprove
                                              }
                                          >
                                            {row.pos_auth_timeoff_str}
                                          </span>
                                        </TableCell>

                                        
                                        


                                        <TableCell className="text-center">
                                          <span
                                            className={
                                              row.pos_status === 1
                                                ? ConfigETC.Status_active
                                                : ConfigETC.Status_inactive
                                              }
                                          >
                                            {row.pos_status_str}
                                          </span>
                                        </TableCell>
                                        <TableCell className="text-center py-0 align-middle">
                                        {(isPermissionEdit === true) &&
                                          <div>
                                            {(listPosition.length === 1 &&
                                              <div>
                                              </div>
                                              ) ||
                                              (row.rowindex === 1 ? (
                                              <div>
                                                  <a href="#!" title="down" onClick={() => Onclick_Sorting_Position("down",row.pos_id)} >
                                                      <i className="fas fa-arrow-alt-circle-down fa-lg"></i>
                                                  </a>
                                              </div>
                                              ) : row.rowindex === isCount ? (
                                                <a href="#!" title="up" onClick={() => Onclick_Sorting_Position("up",row.pos_id)} >
                                                  <i className="fas fa-arrow-alt-circle-up fa-lg"/>
                                                </a>
                                              ) : (
                                              <>
                                                  <a href="#!" title="up" onClick={() => Onclick_Sorting_Position("up",row.pos_id)} >
                                                  <i className="fas fa-arrow-alt-circle-up fa-lg" />
                                                  </a>
                                                  <a href="#!" title="down" onClick={() => Onclick_Sorting_Position("down",row.pos_id)}>
                                                  <i className="fas fa-arrow-alt-circle-down fa-lg" />
                                                  </a>
                                              </>
                                              ))}
                                            </div>
                                          }
                                        </TableCell>
                                        <TableCell className="text-right py-0 align-middle">
                                          <div className="btn-group btn-group-sm">
                                            <Link
                                              to={"../" + Pathurl.m_position_ae}
                                              state={{
                                                pos_id: Class_ETC_Encrypt(row.pos_id.toString()),
                                                act: ActEdit 
                                              }}
                                              className="btn btn-primary btn-sm"
                                            >
                                              <i className="fas fa-pencil-alt" />
                                            </Link>
                                            {(isPermissionDel === true) &&
                                              <a
                                                href="#!"
                                                className="btn btn-default"
                                                title="ลบ"
                                                onClick={() => Onclick_DeletePossition(row.pos_id.toString())}
                                              >
                                                <i className="fas fa-trash" />
                                              </a>
                                            }
                                          </div>
                                        </TableCell>
                                      </TableRow>  
                              ))}                                 
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {listPosition.length > 0 && (
                          <TablePagination
                            rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                            component="div"
                            count={listPosition.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={PaginationActions}
                          />
                  )}
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_position;
